module.exports = __webpack_public_path__ + "img/formula_parcela_variavel.8102af3e.png";